import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, take } from 'rxjs';

export const isAuthenticated = () => {
     const oidcSecurityService = inject(OidcSecurityService);
     const router = inject(Router);
   
     return oidcSecurityService.checkAuth().pipe(
       //take(1),
       map(({ isAuthenticated }) => {
         // allow navigation if authenticated
         if (isAuthenticated) {
           return true;
         }
         else {
          console.log("%cNot Authenticated. Redirecting to login...", "color: orange");
          oidcSecurityService.authorize();
          return false;
         }
         // redirect if not authenticated
         //console.log('Unauthorized');
         //return router.parseUrl('/unauthorized');
       })
     );
   };